import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/img/logo.svg";

const Sidebar = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("user");
    navigate("/login");
  };

  return (
    <aside
      className={`
        fixed inset-y-0 left-0 z-40 w-64 bg-white
        flex flex-col
        min-h-screen
        transform transition-transform duration-300
        ${open ? "translate-x-0" : "-translate-x-full"}
        lg:translate-x-0 lg:static
      `}>
      <div className="p-5 border-b flex items-center gap-3">
        <img src={Logo} alt="MariKerja" className="h-8 w-auto" />
      </div>

      <nav className="p-4 space-y-2 flex-1">
        <Link to={"/dashboard"} className="block p-2 rounded hover:bg-gray-100">
          Dashboard
        </Link>
        <Link
          to={"/dashboard/list-job-vacancy"}
          className="block p-2 rounded hover:bg-gray-100">
          List Pekerjaan
        </Link>
        <Link
          to={"/dashboard/list-job-vacancy/form"}
          className="block p-2 rounded hover:bg-gray-100">
          Tambah Pekerjaan
        </Link>
        <Link
          to={"/dashboard/profile"}
          className="block p-2 rounded hover:bg-gray-100">
          Profile
        </Link>
      </nav>

      <div className="p-4 border-t flex flex-col gap-2">
        <Link
          to={"/dashboard/change-password"}
          className="block p-2 rounded hover:bg-gray-100 text-indigo-600 font-medium">
          Ganti Password
        </Link>
        <button
          onClick={handleLogout}
          className="block w-full text-left p-2 rounded hover:bg-red-100 text-red-600 font-medium">
          Logout
        </button>
      </div>

      <button onClick={onClose} className="absolute top-4 right-4 lg:hidden">
        ✕
      </button>
    </aside>
  );
};

export default Sidebar;
